import { getIOExtensionSpec } from 'z3k-parser/model/device-spec/io-extensions-spec';
import { removeNulls } from 'utils';
import { parsePhysicalIO } from 'z3k-parser/lib/input-outputs/utils';
function pinIdEquals(a, b) {
    return a.blockId == b.blockId && a.pinNumber == b.pinNumber;
}
export function pinIdInArray(needle, haystack) {
    return haystack.some((id) => pinIdEquals(id, needle));
}
export function pinAlreadyUse(needle, haystack) {
    return haystack.filter((id) => pinIdEquals(id, needle)).length > 1;
}
export function inputValue2PinId(device_spec, inputValue, io_extensions, radio_relays, only_clashes) {
    const { num, obj_type, name } = inputValue;
    const { block_id, input_number } = parsePhysicalIO(num);
    if (block_id == null) {
        const inpPinNumber = device_spec.io.inputs.find((input) => input.value == input_number)?.pin_number;
        let ntcPinNumber = undefined;
        if (!only_clashes) {
            ntcPinNumber = device_spec.io.ntc_inputs.find((ntc) => ntc.value == input_number)?.pin_number;
        }
        const pinNumber = inpPinNumber ?? ntcPinNumber;
        if (pinNumber == null) {
            return null;
        }
        return { blockId: null, pinNumber, obj_type, obj_name: name };
    }
    else {
        const io_ext = [...io_extensions, ...radio_relays].find((obj) => obj.id == block_id);
        if (io_ext) {
            const spec = getIOExtensionSpec(io_ext.type, io_ext.serial, device_spec);
            const inpPinNumber = spec.inputs.find((inp) => inp.value == input_number)?.pin_number;
            let ntcPinNumber = undefined;
            if (!only_clashes) {
                ntcPinNumber = spec.ntc_inputs.find((ntc) => ntc.value == input_number)?.pin_number;
            }
            const pinNumber = inpPinNumber ?? ntcPinNumber;
            if (pinNumber == null) {
                return null;
            }
            return {
                blockId: io_ext.id,
                pinNumber,
                obj_type,
                obj_name: name,
            };
        }
        return null;
    }
}
export function inputValues2PinIds(spec, inputValues, io_extensions, radio_relays, only_clashes) {
    return removeNulls(inputValues.map((inputValue) => inputValue2PinId(spec, inputValue, io_extensions, radio_relays, only_clashes)));
}
export function outputValue2PinId(device_spec, outputValue, io_extensions, radio_relays) {
    const { num, obj_type, name, is_inverse } = outputValue;
    const { block_id, input_number } = parsePhysicalIO(num);
    if (block_id == null) {
        const relayPinNumber = device_spec.io.relay_outputs.find((relay) => relay.value == input_number)?.pin_number;
        const ocPinNumber = device_spec.io.open_collector_outputs.find((oc) => oc.value == input_number)?.pin_number;
        const pinNumber = relayPinNumber ?? ocPinNumber;
        if (pinNumber == null) {
            return null;
        }
        return { blockId: null, pinNumber, obj_type, obj_name: name, is_inverse };
    }
    else {
        const io_ext = [...io_extensions, ...radio_relays].find((obj) => obj.id == block_id);
        if (io_ext) {
            const spec = getIOExtensionSpec(io_ext.type, io_ext.serial, device_spec);
            const relayPinNumber = spec.relay_outputs.find((relay) => relay.value == input_number)?.pin_number;
            const ocPinNumber = spec.open_collector_outputs.find((oc) => oc.value == input_number)?.pin_number;
            let pinNumber = relayPinNumber ?? ocPinNumber;
            if (obj_type == 'analog_outputs') {
                pinNumber = spec.analog_outputs.find((oc) => oc.value == input_number)?.pin_number;
            }
            if (pinNumber == null) {
                return null;
            }
            return {
                blockId: io_ext.id,
                pinNumber,
                obj_type,
                obj_name: name,
                is_inverse,
            };
        }
        return null;
    }
}
export function outputValues2PinIds(spec, outputValues, io_extensions, radio_relays) {
    return removeNulls(outputValues.map((outputValue) => outputValue2PinId(spec, outputValue, io_extensions, radio_relays)));
}
